<template>
  <div class="dropdown" v-if="isLoginBarVisible">
    <button
      id="Cta-login-dropdown"
      class="btn btn-block dropdown-toggle"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <template v-if="user">
        <div class="d-flex px-3 py-2 align-items-center">
          <font-awesome-icon
            icon="user-circle"
            size="2x"
            style="vertical-align: middle; background: #e8e8ea; border-radius: 1.25em"
          />&nbsp;
          <span
            class="mx-2 d-none d-sm-inline-block d-md-none d-lg-inline-block text-left align-middle flex-grow-1"
            style="line-height: 1.25em; font-size: 0.9em"
          >
            <span class="font-weight-bold text-truncate" style="max-width: 150px">{{
              $helpers.displayUsername(user)
            }}</span>
            <br class="d-inline-block" />
            <span class="d-inline-block text-muted text-capitalize text-truncate" style="max-width: 150px">{{
              (user && user.practice && user.practice.name) || ''
            }}</span>
          </span>
          <font-awesome-icon :icon="['far', 'angle-down']" class="ml-1" />
        </div>
      </template>
      <small v-else class="text-muted">Loading...</small>
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <h6 v-if="otherLocations.length" class="dropdown-header">Switch Location</h6>
      <a
        v-for="location in otherLocations"
        :key="location.id"
        class="dropdown-item text-capitalize"
        v-on:click="switchLocation(location.token)"
        href="javascript:void(0);"
        >{{ locationDisplayname(location.name) }}</a
      >
      <div v-if="otherLocations.length > 1" class="dropdown-divider"></div>

      <template v-if="otherPractices.length > 1">
        <h6 class="dropdown-header">Switch Practice</h6>
        <a
          v-for="p in otherPractices"
          :key="p.id"
          class="dropdown-item text-capitalize"
          v-on:click="switchPractice(p.id)"
          href="javascript:void(0);"
          >{{ locationDisplayname(p.name) }}</a
        >
        <div class="dropdown-divider"></div>
      </template>

      <template v-if="otherUsers.length > 1">
        <h6 class="dropdown-header">Switch User</h6>
        <a
          v-for="login in otherUsers"
          :key="login.id"
          class="dropdown-item"
          :class="{ 'font-weight-bolder active': login.id == user.id }"
          v-on:click="switchUser(login.id)"
          href="javascript:void(0);"
          >{{ $helpers.displayUsername(login) }}</a
        >
        <div class="dropdown-divider"></div>
      </template>
      <router-link tag="a" to="/login" class="dropdown-item">Login</router-link>
      <div class="dropdown-divider"></div>
      <template v-if="isOrganization">
        <router-link to="/insights" class="dropdown-item">Report</router-link>
        <div class="dropdown-divider"></div>
      </template>
      <template v-else>
        <router-link tag="a" to="/manage/practice" class="dropdown-item">Settings</router-link>
        <div class="dropdown-divider" v-if="user.is_office_admin"></div>
        <router-link tag="a" to="/manage/help" class="dropdown-item">Contact Us</router-link>
        <div class="dropdown-divider"></div>

        <router-link tag="a" :to="'/manage/users/user/me'" class="dropdown-item">My Profile</router-link>
      </template>
      <template v-if="$store.getters['auth/isSuperUser']">
        <div class="dropdown-divider"></div>
        <router-link tag="a" to="/admin" class="dropdown-item">Admin Report</router-link>
        <div class="dropdown-divider"></div>
        <router-link tag="a" to="/pms-integration" class="dropdown-item">PMS Integration</router-link>
        <div class="dropdown-divider"></div>
      </template>
      <a href="#" @click="signOut" class="dropdown-item">Logout</a>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return { alert: null } //todo: errors and alerts from vuex
  },
  computed: {
    ...mapState('auth', {
      user: (state) => state.user,
      isLoginBarVisible: (state) => !!state.logins.length,
      logins: (state) => state.logins.filter((s) => !s.is_public),
      locations: (state) => state.user.practice.other_locations,
    }),

    ...mapGetters('auth', ['isLoggedIn', 'isOrganization']),

    ...mapGetters('notifications', {
      errorList: 'errors',
      successList: 'success',
      infoList: 'info',
    }),

    ...mapState('conferences', ['conference']),

    loginsByPractice() {
      return this.logins //.map(s=)
    },

    isPracticeActive() {
      return this.isLoggedIn && this.user.practice.status == 1 && this.user.practice.is_setup_complete
    },

    otherLocations() {
      const allLogins = this.$store.state.auth.logins
      const othersWithToken = allLogins
        .filter((s) => !s.is_public && s.practice.other_locations?.length)
        .flatMap((s) => [...s.practice.other_locations, { ...s.practice, token: s.token }])
      const withoutCurrent = othersWithToken.filter((s) => s.id != this.user.practice.id)
      return withoutCurrent
      return this.locations
    },

    otherPractices() {
      return (
        this.user.practices
          // .filter((s) => s.id != this.user.practice.id)
          .map((s) => ({ ...s, token: this.$store.state.auth.token }))
      )
    },

    otherUsers() {
      const locationTokens = this.otherLocations.map((s) => s.token)
      console
      return this.logins.filter((s) => !locationTokens.includes(s.token))
    },
  },
  methods: {
    async signOut() {
      // const res = await this.$helpers.confirm('Logout on all devices?', 'Would you like to log out all devices?')
      this.$store.dispatch('auth/logout')
    },
    switchUser(userId) {
      const route = this.$route
      const router = this.$router
      const isChangingPractice = this.user.practice.id != this.otherUsers.find((s) => s.id == userId)?.practice
      this.$store.dispatch('auth/switchUser', { userId }).then(() => {
        if (route.name === 'Login' || isChangingPractice) router.push('/')
      })
    },
    async switchLocation(token) {
      //todo: handle expired tokens
      await this.$store.dispatch('auth/loginViaToken', { token })
      this.$router.push('/')
    },
    async switchPractice(id) {
      await this.$store.dispatch('auth/switchPractice', id)
      this.$router.push('/')
    },
    locationDisplayname(locationName) {
      let name = locationName.toLowerCase()
      //todo: prone to errors, can't have nested parentheses, a single ) would fail too
      return name.endsWith(')') ? name.match(/.*\(([^)]+)\)/)[1] : name
    },
  },
}
</script>

<style scoped>
.btn {
  border-radius: 0;
  color: var(--light-color);
}
.dropdown-toggle {
  padding: 0;
}
.dropdown-toggle::after {
  display: none;
}
</style>
